import styled from '@emotion/styled'
import { DESKTOP_BREAKPOINT } from 'src/constants/breakPoints'

type HiddenProps = {
  only: 'sm' | 'lg'
}

const Hidden = styled('div')`
  display: ${(props: HiddenProps) => (props.only === 'lg' ? 'block' : 'none')};
  ${DESKTOP_BREAKPOINT} {
    display: ${(props: HiddenProps) => (props.only === 'lg' ? 'none' : 'block')};
  }
`

export default Hidden
